import React from 'react';
import PropTypes from 'prop-types';
import FormWrapper from './form-wrapper';

class OrderDeliveryForm extends React.Component {
  constructor(props) {
    super(props);
    const config = [
      {
        label: 'Citofono',
        name: 'citofono',
        format: 'string',
        placeholder: 'Citofono',
        initialValue: '',
        isRequired: true,
      },
      ...props.baseConfig,
    ];
    this.formConfig = config.reduce((acc, field) => {
      return [
        ...acc,
        {
          ...field,
          initialValue: props.initialData[field.name] || '',
        },
      ];
    }, []);
  }

  render() {
    return (
      <FormWrapper
        config={this.formConfig}
        onValidSave={this.props.onSave}
        submitButtonLabel="SALVA E CONTINUA"
      />
    );
  }
}

OrderDeliveryForm.propTypes = {
  initialData: PropTypes.shape({
    email: PropTypes.string,
    id: PropTypes.string,
    accessToken: PropTypes.string,
    lastName: PropTypes.string,
    name: PropTypes.string,
  }),
  onSave: PropTypes.func.isRequired,
};

export default OrderDeliveryForm;



// WEBPACK FOOTER //
// ./src/components/order-delivery-form.js